<div class="loading-overlay" *ngIf="isLoading">
  <div class="loader-container">
    <div class="loader-spinner"></div>
    <p class="loader-text">Chargement en cours...</p>
  </div>
</div>

<div class="min-h-screen bg-white">
  <div class="max-w-full mx-auto py-6">
        <div class="system-connection-table-container">
        <div class="px-6 py-4 border-b border-gray-200 flex items-center gap-4">
          <div class="flex-1 flex items-center justify-center gap-3">
            <div class="relative w-full max-w-xs">
              <span class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 material-symbols-outlined text-sm">search</span>
              <input
                type="text"
                class="w-full pl-9 pr-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
                [(ngModel)]="searchTerm"
                placeholder="Rechercher par nom de machine ou webhook URL..."
              />
            </div>
            <span class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-700 whitespace-nowrap">
              {{ filtered.length }} connexion{{ filtered.length > 1 ? 's' : '' }}
            </span>
          </div>
        </div>

        <div class="table-wrapper">
          <table class="system-connection-table">
            <thead class="system-connection-table-header">
              <tr>
                <th class="text-center cursor-pointer hover:bg-gray-50 transition-colors col-priority" (click)="toggleSort('priorite')">
                  <div class="flex items-center justify-center gap-2">
                    <span>Priorité</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'priorite' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'priorite'">↕</span>
                      <span *ngIf="sortField === 'priorite' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'priorite' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="cursor-pointer hover:bg-gray-50 transition-colors col-name" (click)="toggleSort('name')">
                  <div class="flex items-center gap-2">
                    <span>Nom machine</span>
                    <span class="sort-icon text-xs" [ngClass]="sortField === 'name' ? (sortDirection === 'asc' ? 'asc' : 'desc') : ''">
                      <span *ngIf="sortField !== 'name'">↕</span>
                      <span *ngIf="sortField === 'name' && sortDirection === 'asc'">↓</span>
                      <span *ngIf="sortField === 'name' && sortDirection === 'desc'">↑</span>
                    </span>
                  </div>
                </th>
                <th class="col-strategy">Stratégie</th>
                <th class="col-webhook">Webhook URL</th>
                <th class="col-reception text-center">Réception</th>
                <th class="col-price text-center">Prix avant switch</th>
                <th class="col-price text-center">Prix avant envoi</th>
                <th class="text-center col-actions">Actions</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr *ngFor="let m of filtered" class="system-connection-table-row">
                <td class="system-connection-table-cell text-center">
                  <span class="priority-badge">{{ m.priorite || 0 }}</span>
                </td>
                <td class="system-connection-table-cell">
                  <div class="device-name-modern">
                    <div class="name-row">
                      <div class="name-row-left">
                        <span class="connection-status-icon-inline" 
                              [ngClass]="{'online': m.isOnline, 'offline': !m.isOnline}"
                              [title]="m.isOnline ? 'En ligne' : 'Hors ligne'">
                          <span class="material-symbols-outlined">{{ m.isOnline ? 'wifi' : 'wifi_off' }}</span>
                        </span>
                        <span class="device-name-text" 
                              (click)="openDeviceUrl(m)"
                              [ngClass]="{'has-url': m.ip, 'no-url': !m.ip}">
                          {{ getMachineNameParts(m.name || '').main || 'Machine sans nom' }}
                        </span>
                      </div>
                    </div>
                    <span class="device-name-parenthetical" *ngIf="getMachineNameParts(m.name || '').parenthetical">{{ getMachineNameParts(m.name || '').parenthetical }}</span>
                  </div>
                </td>
                <td class="system-connection-table-cell">
                  <ng-container *ngIf="m.selectedStrategie; else noStrategy">
                    <ng-container *ngIf="getStrategy(m.selectedStrategie) as strategy">
                      <div class="strategy-display-modern">
                        <button 
                          type="button"
                          class="strategy-operator-text" 
                          (click)="openStrategyModal(strategy); $event.stopPropagation()"
                          title="Cliquer pour voir les détails de la stratégie">
                          {{ strategy?.operateur || '-' }}
                        </button>
                        <span class="strategy-type-badge" 
                              [ngClass]="(strategy?.typeStrategie?.toLowerCase() === 'court terme') ? 'strategy-type-short' : 'strategy-type-long'">
                          {{ strategy?.typeStrategie | uppercase }}
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!getStrategy(m.selectedStrategie)">
                      <span class="strategy-empty">-</span>
                    </ng-container>
                  </ng-container>
                  <ng-template #noStrategy>
                    <span class="strategy-empty">-</span>
                  </ng-template>
                </td>
                <td class="system-connection-table-cell">
                  <div class="flex items-center gap-2">
                    <span class="webhook-url-text whitespace-nowrap overflow-hidden text-ellipsis">{{ getWebhookName(m.webhookUrl) }}</span>
                    <button class="webhook-copy-btn" 
                            type="button" 
                            (click)="copyWebhook(m.webhookUrl)"
                            title="Copier le webhook URL"
                            *ngIf="getWebhookUrl(m.webhookUrl)">
                      <span class="material-symbols-outlined text-sm">content_copy</span>
                    </button>
                  </div>
                </td>
                <td class="system-connection-table-cell text-center">
                  <span class="reception-badge" 
                        [ngClass]="{'reception-badge-active': m.usedForReception, 'reception-badge-inactive': !m.usedForReception}">
                    <span class="material-symbols-outlined reception-icon">{{ m.usedForReception ? 'check_circle' : 'cancel' }}</span>
                    <span class="reception-text">{{ m.usedForReception ? 'Oui' : 'Non' }}</span>
                  </span>
                </td>
                <td class="system-connection-table-cell text-center">
                  <span class="price-display">{{ m.remunerationReceptionSwitch || '0' }}$</span>
                </td>
                <td class="system-connection-table-cell text-center">
                  <span class="price-display">{{ m.remunerationReceptionEnvoi || '0' }}$</span>
                </td>
                <td class="system-connection-table-cell text-center">
                  <div class="actions-row-modern">
                    <button 
                      type="button" 
                      class="btn-action-modern btn-edit" 
                      (click)="openEditModal(m)"
                      title="Modifier">
                      <span class="material-symbols-outlined">edit</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>

<div class="strategies-modal-overlay" *ngIf="showStrategyModal">
  <div class="strategies-modal-content" #strategyModalContent>
    <div class="strategies-modal-header">
      <div class="flex items-center gap-2.5">
        <div class="w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg flex items-center justify-center shadow-sm">
          <span class="material-symbols-outlined text-white text-lg">settings</span>
        </div>
        <h2 class="text-base font-semibold text-gray-900 tracking-tight">Détails de la stratégie</h2>
      </div>
      <button 
        class="modal-close-btn w-9 h-9 flex items-center justify-center rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-50 active:bg-gray-100 transition-all duration-200"
        (click)="closeStrategyModal()" 
        type="button"
        title="Fermer">
        <span class="material-symbols-outlined text-xl">close</span>
      </button>
    </div>
    
    <div class="strategies-modal-body" *ngIf="viewingStrategy">
      <form>
        <div class="mb-6">
          <div class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Opérateur
                </label>
                <input 
                  type="text" 
                  class="strategies-form-input" 
                  [value]="viewingStrategy.operateur || ''" 
                  placeholder="Ex: Orange, SFR, Free..."
                  disabled />
              </div>
              
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Prix carte
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="number" 
                  class="strategies-form-input" 
                  [value]="viewingStrategy.prixCarte || 0" 
                  placeholder="Ex: 10.50" 
                  step="0.01" 
                  min="0.01" 
                  disabled />
              </div>
            </div>
            
            <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Type de stratégie
                </label>
                <select 
                  class="strategies-form-select" 
                  [value]="viewingStrategy.typeStrategie || ''"
                  disabled>
                  <option value="court terme">Court terme (One shot)</option>
                  <option value="long terme">Long terme</option>
                </select>
              </div>
              
              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Type d'envoi
                  <span class="text-red-500">*</span>
                </label>
                <select 
                  class="strategies-form-select" 
                  [value]="viewingStrategy.typeEnvoi || ''"
                  disabled>
                  <option value="SMS">SMS uniquement</option>
                  <option value="MMS">MMS uniquement</option>
                  <option value="SMS & MMS">SMS + MMS</option>
                </select>
              </div>

              <div class="flex flex-col gap-1">
                <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                  Nombre de puces simultanées
                  <span class="text-red-500">*</span>
                </label>
                <input 
                  type="number" 
                  class="strategies-form-input" 
                  [value]="viewingStrategy.nbMaxPuceSimultanee || 1" 
                  placeholder="Ex: 3"
                  min="1" 
                  disabled />
              </div>
            </div>
          </div>
        </div>

        <ng-container *ngIf="viewingStrategy.typeEnvoi === 'SMS' || viewingStrategy.typeEnvoi === 'SMS & MMS'">
          <div class="border-t border-gray-100 pt-4 mb-4">
            <h6 class="text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span class="material-symbols-outlined text-base text-blue-600">message</span>
              Paramètres SMS
            </h6>
            <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="viewingStrategy.typeStrategie === 'court terme'">
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de début SMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.minuteDebutSMS ? viewingStrategy.minuteDebutSMS.join(',') : ''" 
                    placeholder="Ex: 0,15,30"
                    disabled />
                </div>
                
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de fin SMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.minuteFinSMS ? viewingStrategy.minuteFinSMS.join(',') : ''" 
                    placeholder="Ex: 10,25,40"
                    disabled />
                </div>
              </div>

              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par minute
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaMinSMS || 0" 
                    placeholder="Ex: 5"
                    min="1" 
                    disabled />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par heure
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaHSMS || 0" 
                    placeholder="Ex: 100"
                    min="1" 
                    disabled />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    <span *ngIf="viewingStrategy.typeStrategie === 'court terme'">Quota fixe SMS</span>
                    <span *ngIf="viewingStrategy.typeStrategie !== 'court terme'">Quota par jour</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    *ngIf="viewingStrategy.typeStrategie === 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaFixeSMS || 0" 
                    placeholder="Ex: 1000" 
                    min="1" 
                    disabled />
                  <input 
                    *ngIf="viewingStrategy.typeStrategie !== 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaJourSMS || 0" 
                    placeholder="Ex: 500"
                    min="1" 
                    disabled />
                </div>
              </div>
              
              <div *ngIf="viewingStrategy.typeStrategie === 'court terme'">
                <small class="text-xs text-gray-500">Nombre total de SMS à envoyer pour cette stratégie</small>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="viewingStrategy.typeEnvoi === 'MMS' || viewingStrategy.typeEnvoi === 'SMS & MMS'">
          <div class="border-t border-gray-100 pt-4">
            <h6 class="text-base font-semibold text-gray-900 mb-3 flex items-center gap-2">
              <span class="material-symbols-outlined text-base text-purple-600">image</span>
              Paramètres MMS
            </h6>
            <div class="space-y-4">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4" *ngIf="viewingStrategy.typeStrategie === 'court terme'">
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de début MMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.minuteDebutMMS ? viewingStrategy.minuteDebutMMS.join(',') : ''" 
                    placeholder="Ex: 5,20"
                    disabled />
                </div>
                
                <div class="flex flex-col gap-1">
                  <label class="text-sm font-medium text-gray-700">Minutes de fin MMS</label>
                  <input 
                    type="text" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.minuteFinMMS ? viewingStrategy.minuteFinMMS.join(',') : ''" 
                    placeholder="Ex: 15,35"
                    disabled />
                </div>
              </div>

              <div class="flex flex-row gap-3">
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par minute
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaMinMMS || 0" 
                    placeholder="Ex: 2"
                    min="1" 
                    disabled />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    Quota par heure
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaHMMS || 0" 
                    placeholder="Ex: 50"
                    min="1" 
                    disabled />
                </div>
                
                <div class="flex flex-col gap-1 flex-1">
                  <label class="text-sm font-medium text-gray-700 flex items-center gap-1">
                    <span *ngIf="viewingStrategy.typeStrategie === 'court terme'">Quota fixe MMS</span>
                    <span *ngIf="viewingStrategy.typeStrategie !== 'court terme'">Quota par jour</span>
                    <span class="text-red-500">*</span>
                  </label>
                  <input 
                    *ngIf="viewingStrategy.typeStrategie === 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaFixeMMS || 0" 
                    placeholder="Ex: 100" 
                    min="1" 
                    disabled />
                  <input 
                    *ngIf="viewingStrategy.typeStrategie !== 'court terme'"
                    type="number" 
                    class="strategies-form-input" 
                    [value]="viewingStrategy.quotaJourMMS || 0" 
                    placeholder="Ex: 200"
                    min="1" 
                    disabled />
                </div>
              </div>
              
              <div *ngIf="viewingStrategy.typeStrategie === 'court terme'">
                <small class="text-xs text-gray-500">Nombre total de MMS à envoyer pour cette stratégie</small>
              </div>
            </div>
          </div>
        </ng-container>
      </form>
    </div>
    
    <div class="strategies-modal-footer">
      <button 
        type="button" 
        class="strategies-btn-secondary"
        (click)="closeStrategyModal()">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Fermer</span>
      </button>
    </div>
  </div>
</div>

<div class="system-connection-modal-overlay" *ngIf="showEditModal">
  <div class="system-connection-modal-content" #editModalContent>
    <div class="system-connection-modal-header">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
          <span class="material-symbols-outlined text-white text-lg">edit</span>
        </div>
        <h2 class="text-lg font-semibold text-gray-900">Modifier la connexion</h2>
      </div>
      <div class="flex items-center gap-4">
        <div class="flex items-center gap-2">
          <input 
            type="checkbox" 
            id="usedForReception"
            class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500 cursor-pointer" 
            [(ngModel)]="editingMachine.usedForReception" 
            name="usedForReception" />
          <label for="usedForReception" class="text-sm font-medium text-gray-700 cursor-pointer">
            Utilisé pour la réception
          </label>
        </div>
        <button 
          class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 active:bg-gray-200 transition-all duration-200 text-gray-400 hover:text-gray-600"
          (click)="closeEditModal()" 
          type="button"
          [disabled]="isSaving">
          <span class="material-symbols-outlined text-lg">close</span>
        </button>
      </div>
    </div>
    
    <div class="system-connection-modal-body">
      <form (ngSubmit)="saveFromModal(); $event.preventDefault()" id="editForm">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700">Nom machine</label>
            <input 
              type="text" 
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white" 
              [(ngModel)]="editingMachine.name" 
              name="name" 
              required />
          </div>

          <div class="flex flex-col gap-1.5 relative webhook-dropdown-container">
            <label class="text-sm font-medium text-gray-700">Webhook de réception</label>
            <div class="relative">
              <button
                type="button"
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white text-left flex items-center justify-between cursor-pointer hover:border-gray-400"
                (click)="toggleWebhookDropdown()">
                <span class="truncate flex-1">
                  <span *ngIf="(editingMachine.selectedWebhookIds?.length || 0) === 0" class="text-gray-400">
                    Sélectionner un ou plusieurs webhooks
                  </span>
                  <span *ngIf="(editingMachine.selectedWebhookIds?.length || 0) > 0" class="text-gray-900">
                    {{ getSelectedWebhooksDisplay() }}
                  </span>
                </span>
                <span class="material-symbols-outlined text-base text-gray-400 ml-2 flex-shrink-0 transition-transform"
                      [class.rotate-180]="showWebhookDropdown">
                  expand_more
                </span>
              </button>
              
              <div 
                *ngIf="showWebhookDropdown"
                class="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-64 overflow-y-auto"
                (click)="$event.stopPropagation()">
                <div *ngIf="webhooks.length === 0" class="px-3 py-4 text-sm text-gray-500 text-center">
                  Aucun webhook disponible
                </div>
                <div *ngFor="let webhook of webhooks" 
                     class="px-3 py-2 hover:bg-gray-50 cursor-pointer flex items-center gap-3 border-b border-gray-100 last:border-b-0 transition-colors"
                     (click)="toggleWebhookSelection(webhook._id)">
                  <input
                    type="checkbox"
                    [id]="'webhook-' + webhook._id"
                    class="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 cursor-pointer pointer-events-none"
                    [checked]="editingMachine.selectedWebhookIds?.includes(webhook._id)"
                    readonly
                  />
                  <label [for]="'webhook-' + webhook._id" class="flex-1 cursor-pointer pointer-events-none">
                    <div class="font-medium text-sm text-gray-900">{{ webhook.nom }}</div>
                    <div class="text-xs text-gray-500 truncate" *ngIf="webhook.webhookUrlReceipt">
                      {{ webhook.webhookUrlReceipt }}
                    </div>
                  </label>
                </div>
                <div *ngIf="webhooks.length > 0 && (editingMachine.selectedWebhookIds?.length || 0) > 0" 
                     class="px-3 py-2 border-t border-gray-200 bg-gray-50">
                  <button
                    type="button"
                    class="w-full text-xs text-blue-600 hover:text-blue-700 font-medium text-center"
                    (click)="clearAllWebhooks(); $event.stopPropagation()">
                    Tout désélectionner
                  </button>
                </div>
              </div>
            </div>
            <p class="text-xs text-gray-500">
              {{ (editingMachine.selectedWebhookIds?.length || 0) }} webhook{{ (editingMachine.selectedWebhookIds?.length || 0) > 1 ? 's' : '' }} sélectionné{{ (editingMachine.selectedWebhookIds?.length || 0) > 1 ? 's' : '' }}
            </p>
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700">Identifiant</label>
            <input 
              type="text" 
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white" 
              [(ngModel)]="editingMachine.identifiant" 
              name="identifiant" />
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700">Mot de passe</label>
            <div class="flex items-center gap-2">
              <input 
                [type]="showPassword ? 'text' : 'password'"
                class="flex-1 max-w-xs px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white font-mono" 
                [(ngModel)]="editingMachine.passwordInput" 
                name="password" />
              <button 
                type="button"
                class="w-7 h-7 flex items-center justify-center rounded hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700"
                (click)="showPassword = !showPassword"
                title="Afficher/Masquer">
                <span class="material-symbols-outlined text-base" *ngIf="!showPassword">visibility</span>
                <span class="material-symbols-outlined text-base" *ngIf="showPassword">visibility_off</span>
              </button>
            </div>
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700">Adresse IP</label>
            <div class="flex items-center gap-2">
              <input 
                type="text" 
                class="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white font-mono" 
                [(ngModel)]="editingMachine.ip" 
                name="ip" />
              <button 
                type="button"
                class="w-7 h-7 flex items-center justify-center rounded hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700" 
                (click)="copyFormattedIp(editingMachine.ip)"
                title="Copier">
                <span class="material-symbols-outlined text-base">content_copy</span>
              </button>
            </div>
          </div>

          <div class="flex flex-col gap-1.5">
            <label class="text-sm font-medium text-gray-700">IP Secondaire</label>
            <div class="flex items-center gap-2">
              <input 
                type="text" 
                class="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white font-mono" 
                [(ngModel)]="editingMachine.ipSecondaire" 
                name="ipSecondaire" />
              <button 
                type="button"
                class="w-7 h-7 flex items-center justify-center rounded hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700" 
                (click)="copyFormattedIp(editingMachine.ipSecondaire)"
                title="Copier">
                <span class="material-symbols-outlined text-base">content_copy</span>
              </button>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-gray-700">Stratégie</label>
              <select 
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white cursor-pointer" 
                [(ngModel)]="editingMachine.selectedStrategie" 
                name="strategie">
                <option [ngValue]="null" disabled>Sélectionner</option>
                <option *ngFor="let s of strategies" [value]="s._id">
                  {{ s.operateur }} ({{ s.typeStrategie }})
                </option>
              </select>
            </div>

            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-gray-700">Prix avant Envoi ($)</label>
              <input 
                type="number" 
                step="0.1" 
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white" 
                [(ngModel)]="editingMachine.remunerationReceptionEnvoi" 
                name="remunerationEnvoi" />
            </div>

            <div class="flex flex-col gap-1.5">
              <label class="text-sm font-medium text-gray-700">Prix avant switch ($)</label>
              <input 
                type="number" 
                step="0.1" 
                class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all text-sm bg-white" 
                [(ngModel)]="editingMachine.remunerationReceptionSwitch" 
                name="remunerationSwitch" />
            </div>
          </div>
        </div>
      </form>
    </div>
    
    <div class="system-connection-modal-footer">
      <button 
        type="button" 
        class="system-connection-btn-secondary"
        (click)="closeEditModal()"
        [disabled]="isSaving">
        <span class="material-symbols-outlined text-base">close</span>
        <span>Annuler</span>
      </button>
      <button 
        type="submit" 
        class="system-connection-btn-primary"
        form="editForm"
        [disabled]="isSaving">
        <span *ngIf="!isSaving" class="flex items-center gap-2">
          <span class="material-symbols-outlined text-base">save</span>
          <span>Enregistrer</span>
        </span>
        <span *ngIf="isSaving" class="flex items-center gap-2">
          <div class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          <span>Enregistrement...</span>
        </span>
      </button>
    </div>
</div>
